import { useEffect, useState } from "react"
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { verPdfIRPFhabilitado } from "../../components/services/IRPFService";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";

const VerPDFirpfHab = () => {
    const [solicitud, setSolicitud] = useState();
    const [loading, setLoading] = useState(false);
    // const [file,setFile] = useState();
    // const [user] = useLocalStorage('user','')
    const location = useLocation();
    const navigate = useNavigate();

    const anyo = location?.state?.anyo || localStorage.getItem("anyoIRPFHabilitado");
 

    // const hanndleDescargaPDF = (file) =>{
    //     if (file.size !== 0) {
    //         const fileURL = URL.createObjectURL(file);
    //         const link = document.createElement("a");
    //         link.href = fileURL;
    //         link.download = `IRPF_HABILITACIONES${user.niep}${user.letniep}.pdf`;
    //         link.click();
    //         link.remove();
    //     }
    // }

    useEffect(() => {
        setLoading(true)
        verPdfIRPFhabilitado(anyo).then((data) => {
            //Este if es para el caso que quieras descargarlo independientemente de la preview

            // if (!data.toString().startsWith("Error")) {
            //     
            //     const file = new Blob([data], {
            //         type: "application/pdf",
            //     });
            //     setFile(file);
            // } else {

            // }
            // // setLoadingButton(true);

            if (!data.toString().startsWith("Error:") && data !== null) {
                var reader = new FileReader();
                reader.readAsDataURL(data);
                reader.onloadend = function () {
                    var base64data = reader.result;
                    setSolicitud(base64data);
                    setLoading(false);
                };
            } else {
                //setLoading(true);
            }
        });
    }, [location,anyo])

    
    
    return (<>
        <Header />
        <div className="container-fluid" role="main" data-landmark-index="4">
            <div className="datosPersonalesCarrera d-flex flex-column m-2">
                <div>
                    <div className="d-flex justify-content-between">
                        {/*<Titulo
                            clases={"subSubTituloSolicitud p-2 fw-bold"}
                            tipo={"tituloCard noBg"}
                            titulo={`IRPF Habilitado`}
                        ></Titulo> */ }
                        <h2 className="tituloAccesibilidadMini">{"IRPF Habilitado - "+anyo}</h2>
                    </div>
                    <div className="separador"></div>
                </div>

                <div className="formulario">
                    <>
                        <div className="m-2"></div>
                        {loading ? (<><SpinnerCircle /></>) : (<>
                            <div className="m-3 card scroll-list container-list-border">
                                <div className="gridPresentar">
                                    <div className="iframePresentar pt-3">
                                        {solicitud && solicitud.split(",")[1] !== "" ? (
                                            <object
                                                data={solicitud}
                                                type="application/pdf"
                                                height="500"
                                                width="100%"
                                                aria-label="PDF del borrador"
                                                className="rounded"
                                                name="sol"
                                            />
                                        ) : (
                                            <p style={{ height: "500px", width: "100%" }}>
                                                No se ha encontrado el documento en el
                                                sistema.
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>)}

                    </>
                    <div className="gridBotones mb-2">
                        <button
                            id="volver"
                            className="btnRed rounded btnCancelarDocumentacion"
                            type="button"
                            onClick={() => navigate("/home")}
                        >
                            <i className="fa-solid fa-rotate-left"></i> Volver
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </>)
}

export default VerPDFirpfHab